import { ClassData } from '@models/class-data';

export class PageStyle {
  id: number;
  primaryColor?: string;
  accentColor?: string;
  backgroundColor?: string;
  titleColor?: string;
  bodyColor?: string;
  cardBackgroundColor?: string;
  cardTitleColor?: string;
  cardBodyColor?: string;
  primaryFont?: string;
  bodyFont?: string;
  primaryFontWeight?: number;
  bodyFontWeight?: number;
  sectionBodyColor?: string;
  sectionBackgroundColor?: string;
  sectionAccentBodyColor?: string;
  sectionAccentBackgroundColor?: string;

  constructor(json: ClassData<PageStyle>) {
    this.id = +json.id;
    this.primaryColor = json.primaryColor;
    this.accentColor = json.accentColor;
    this.backgroundColor = json.backgroundColor;
    this.titleColor = json.titleColor;
    this.bodyColor = json.bodyColor;
    this.cardBackgroundColor = json.cardBackgroundColor;
    this.cardTitleColor = json.cardTitleColor;
    this.cardBodyColor = json.cardBodyColor;
    this.primaryFont = json.primaryFont;
    this.bodyFont = json.bodyFont;
    this.primaryFontWeight = json.primaryFontWeight;
    this.bodyFontWeight = json.bodyFontWeight;
    this.sectionBodyColor = json.sectionBodyColor;
    this.sectionBackgroundColor = json.sectionBackgroundColor;
    this.sectionAccentBodyColor = json.sectionBodyColor;
    this.sectionAccentBackgroundColor = json.sectionAccentBackgroundColor;
  }
}
